import { render, staticRenderFns } from "./integral-rule.vue?vue&type=template&id=06b5d9ab&scoped=true&"
import script from "./integral-rule.vue?vue&type=script&lang=js&"
export * from "./integral-rule.vue?vue&type=script&lang=js&"
import style0 from "./integral-rule.vue?vue&type=style&index=0&id=06b5d9ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b5d9ab",
  null
  
)

export default component.exports